'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var setScrollTop = require('../../../js/setScrollTop');
var resetMarginTop = setScrollTop.resetMarginTop;
var setMarginTop = setScrollTop.setMarginTop;
var modalMini = require('../../modal-mini')
var photoGalleryModal = require('../../modal-gallery')


var modal = document.getElementById('modal')

console.assert(modal instanceof HTMLDivElement, 'Modal not found')
var html = document.documentElement

var set = function (src) {
  // Close mini modals if active
  modalMini.closeMiniModal()

  if (modal.children.length > 0) {
    modal.innerHTML = '';
  }
  modal.appendChild(src)

  if(!html.classList.contains('modal-open')){
    setMarginTop()
    modelHeightCheck()
    photoGalleryModal.setUpBrowserBackButton()
    var ev = new Event('modal-loaded', { bubbles: true })
    document.dispatchEvent(ev)
  }
}

var destroy = function () {
  // IE does not like the use of innerHTML = ''
  if (modal && modal.children.length) {
    modal.removeChild(modal.firstChild)
    html.classList.remove('modal-open', 'fixed')
    resetMarginTop()
  }
}

var modelHeightCheck = function () {
  html.classList.add('modal-open');
  var firstChild = modal.children[0];
  var childHeight = firstChild.clientHeight;

  if(firstChild.dataset.overlayClose){
    childHeight = firstChild.firstElementChild.clientHeight;
  }

  if (childHeight > html.clientHeight){
    modal.classList.remove('fixed');
    //allow background to scrolling
    html.classList.remove('fixed');
    modal.classList.add('absolute');
  } else {
    modal.classList.add('fixed');
    //stop background scrolling
    html.classList.add('fixed');
    modal.classList.remove('absolute');
  }

}

var moveToNextFrame = function (currentFrame, frameName) {
  var nextFrame = modal.querySelector('div[data-frame="' + frameName + '"]')
  if (nextFrame && currentFrame) {
    // Swap frames
    currentFrame.hidden = true
    nextFrame.hidden = false

    return true
  } else {
    return false
  }
}

/* instanbul ignore next */
var close = function (e) {
  var target = e.target.closest('#modal [href], #modal [aria-controls]');
  if (target && html.classList.contains('modal-open')) {
    if (target.dataset.frame && moveToNextFrame(e.target.closest('div[data-frame]'), target.dataset.frame)) {
      e.preventDefault()
      e.stopPropagation()
    } else {
      destroy()
    }
  }
}

var init = function () {
  // If there is a modal supplied from the server - show it
  modal && modal.children.length && modelHeightCheck()
}

document.addEventListener('click', close, true)
document.addEventListener('DOMContentLoaded', init)
document.addEventListener("cm-modal-destroy", destroy);

exports.set = set;
exports.destroy = destroy;
exports.modelHeightCheck = modelHeightCheck;
